import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngDoc service
     *
     * @description
     * Angular `$resource` whose methods should map `ReportingResource` from the backend.
     *
     * @author flzemke.btc
     * @ngInject
     */
    angular.module('app').factory('Report', reportService);

    function reportService($resource, API_URL) {
        return $resource(
            API_URL.REPORTS,
            {},
            {
                query: {
                    isArray: false
                },
                createReport: {
                    method: 'GET',
                    url: API_URL.REPORTS + '/createReport'
                }
            }
        );
    }
})();
